import { useState } from 'react';

const useTimerTile = () => {
  const [isTimerDrawerOpen, setIsTimerDrawerOpen] = useState(false);

  const handleCloseTimerDrawer = () => {
    setIsTimerDrawerOpen(false);
  };

  const handleClick = () => {
    setIsTimerDrawerOpen(true);
  };

  return { isTimerDrawerOpen, handleCloseTimerDrawer, handleClick };
};

export default useTimerTile;
